module.exports = __webpack_public_path__ + "static/media/logo.bc17f9f8.jpg";